
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

import "./SplitBanner.css";

const SplitBanner = () => {

    const [bannerSections, setBannerSections] = useState([]);
    const [error, setError] = useState(null);

    // Fetch banners
    const fetchBannerSections = async () => {
        try {
            const res = await fetch(
                "https://api.welbeing.in/home/get_sub_banners/"
            );

            const data = await res.json();

            if (data.status === "success") {
                setBannerSections(data.data || []);
            } else {
                throw new Error("Failed to fetch banner sections");
            }
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        fetchBannerSections();
    }, []);


    if (error) {
        return null;
    }

    if (!bannerSections?.length ) {
        return null;
    }

    return (
        <div className="split-banner-container">

            <Swiper
                modules={[Autoplay, EffectFade]}
                effect="fade"
                fadeEffect={{
                    crossFade: true,
                }}
                slidesPerView={1}
                slidesPerGroup={1}
                spaceBetween={0}
                loop={bannerSections.length > 1}
                autoplay={
                    bannerSections.length > 1
                        ? {
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }
                        : false
                }
                allowTouchMove={false}
                watchSlidesProgress={true}
                className="split-banner-swiper"
            >
                {bannerSections.map((banner) => (
                    <SwiperSlide key={banner.id}>
                        <section className="split-banner-section">

                            <div className="split-banner-wrapper">

                                {/* Image Side */}
                                <div className="split-banner-img-side">
                                    <img
                                        src={`https://api.welbeing.in/uploads/sub_banners/${banner.image}`}
                                        alt={banner.heading || "Banner"}
                                        className="split-banner-img"
                                    />
                                </div>

                                {/* Content Side */}
                                <div className="split-banner-content-side">

                                    <h2 className="split-banner-heading">
                                        {banner.heading}
                                    </h2>

                                    <p className="split-banner-desc">
                                        {banner.description}
                                    </p>

                                    <a
                                        href={`/products?id=${banner.sub_id}`}
                                        className="split-banner-btn"
                                    >
                                        Shop Now →
                                    </a>

                                </div>

                            </div>

                        </section>
                    </SwiperSlide>
                ))}
            </Swiper>

        </div>
    );
};

export default SplitBanner;
